
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';
    import {TimelineLite} from 'gsap';

    @Component({})
    export default class TheLeagueUser extends Vue {
        @Prop({required: true})
        name!: string;

        @Prop({required: true})
        image!: string;

        mounted() {
            const tl = new TimelineLite({delay: .25});
            tl.staggerFromTo('.league-board', .25, {opacity: 0, scale: .5}, {opacity: 1, scale: 1}, .05);
        }
    }

